import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { WMComponent } from '@front/webmobile/Views/Components/WMComponent';
import { AccountWidgetDragAndDropViewModel } from '../../ViewModels/AccountWidgetDragAndDropViewModel';
export class AccountWidgetDragAndDrop extends WMComponent {
    constructor(props) {
        super(props, AccountWidgetDragAndDropViewModel);
    }
    render() {
        if (isNullOrUndefined(this.props.typePointer)) {
            return null;
        }
        const { HeaderText, firstValue, firstValueColor, secondValue, secondValueColor, left, top } = this.state;
        return (_jsxs("div", { className: "accountWidget-DragAndDrop", style: { position: 'absolute', cursor: 'default', left: left + 'px', top: top + 'px' }, children: [_jsx("div", { className: "accountWidget-DragAndDrop-header", children: HeaderText }), _jsxs("div", { className: "accountWidget-DragAndDrop-value", children: [_jsx("div", { className: firstValueColor, children: firstValue }), secondValue && (_jsxs(_Fragment, { children: [_jsx("div", { children: "/" }), _jsx("div", { className: secondValueColor, children: secondValue })] }))] })] }));
    }
}
